import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { LayoutDashboard, CalendarDays, Newspaper, Package, Inbox, ClipboardList, MessageSquare, LogOut, ArrowUpRight } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { LogoMark } from "../../components/Logo";

const nav = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/events", label: "Events", icon: CalendarDays },
  { to: "/admin/news", label: "News", icon: Newspaper },
  { to: "/admin/equipment", label: "Equipment", icon: Package },
  { to: "/admin/enquiries", label: "Hire Enquiries", icon: Inbox },
  { to: "/admin/submissions", label: "Enquiries", icon: MessageSquare },
  { to: "/admin/bookings", label: "Bookings", icon: ClipboardList },
];

export default function AdminLayout() {
  const { user, signOut } = useAuth();
  const navigate = useNavigate();
  const logout = () => { signOut(); navigate("/admin/login"); };

  return (
    <div className="min-h-screen bg-nead-mist flex">
      <aside className="w-64 flex-none bg-nead-ink text-white flex flex-col fixed inset-y-0 left-0">
        <div className="flex items-center gap-2.5 px-6 h-[74px] border-b border-white/10">
          <LogoMark className="h-8 w-8" />
          <span className="font-display font-bold text-lg tracking-tight">NEAD Admin</span>
        </div>
        <nav className="flex-1 px-3 py-6 space-y-1">
          {nav.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.end}
              data-testid={`admin-nav-${n.label.toLowerCase().replace(/\s/g, "-")}`}
              className={({ isActive }) =>
                `flex items-center gap-3 rounded-lg px-3.5 py-2.5 text-sm font-medium transition-colors ${isActive ? "bg-nead-pink text-white" : "text-white/60 hover:bg-white/5 hover:text-white"}`
              }
            >
              <n.icon className="h-5 w-5" strokeWidth={2} />
              {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="px-3 pb-4 space-y-1 border-t border-white/10 pt-4">
          <a href="/" target="_blank" rel="noreferrer" className="flex items-center gap-3 rounded-lg px-3.5 py-2.5 text-sm font-medium text-white/60 hover:bg-white/5 hover:text-white">
            <ArrowUpRight className="h-5 w-5" /> View site
          </a>
          <button onClick={logout} data-testid="admin-logout" className="w-full flex items-center gap-3 rounded-lg px-3.5 py-2.5 text-sm font-medium text-white/60 hover:bg-white/5 hover:text-white">
            <LogOut className="h-5 w-5" /> Sign out
          </button>
        </div>
      </aside>

      <div className="flex-1 ml-64 min-w-0">
        <header className="h-[74px] bg-white border-b border-black/5 flex items-center justify-end px-8">
          <div className="text-right">
            <div className="text-sm font-semibold text-nead-navy">{user?.name || "Admin"}</div>
            <div className="text-xs text-nead-navy/50">{user?.email}</div>
          </div>
        </header>
        <main className="p-8"><Outlet /></main>
      </div>
    </div>
  );
}
